import familiadosApiClient from '$utils/familiadosApiClient'
import {
  OffSessionClientSecretId,
  PaymentBasicDataDto,
  OnSessionClientSecretId,
  ExtraChargeModel,
  OneTimePremiumPaymentClientSecretId,
  ProSubscriptionPaymentClientSecretId,
  NewPaymentMethodSetup,
  CheckoutPaymentData,
} from './payment.model'
import { apiErrorService } from '$utils/services/apiErrorService'
import {
  basicDataResponseToModel,
  convertEurosToCents,
  mapOneTimePremiumPaymentToDto,
  mapProSubscriptionPaymentToDto,
  mapCheckoutPaymentDataToDto,
} from './payment.mapper'
import { apiRouter } from '$domain/model/apiRouter'
import { OneTimePremiumPlan } from '$domain/model/premium/premium.model'
import { ProSubscriptionPlan } from '$domain/model/pro/pro.model'

export const getOffSessionPaymentClientSecretId = async (requestId: string) => {
  try {
    return await familiadosApiClient.get<OffSessionClientSecretId>(
      apiRouter.getOffSessionPaymentClientSecretIdPath(requestId),
    )
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const sendPaymentId = async (requestId: string, paymentToken?: string) => {
  try {
    return await familiadosApiClient.post(apiRouter.getRecommendationPaymentTokenPath(requestId), { paymentToken })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getPaymentBasicData = async (requestId: string) => {
  try {
    const paymentBasicData = await familiadosApiClient.get<PaymentBasicDataDto>(
      apiRouter.getPaymentBasicDataPath(requestId),
    )
    return basicDataResponseToModel(paymentBasicData)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getOnSessionPaymentClientSecretId = async (requestId: string) => {
  try {
    return await familiadosApiClient.get<OnSessionClientSecretId>(
      apiRouter.getOnSessionPaymentClientSecretIdPath(requestId),
    )
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const sendExtraCharge = async (requestId: string, extraCharge: ExtraChargeModel) => {
  try {
    return await familiadosApiClient.post(apiRouter.getExtraChargePath(requestId), convertEurosToCents(extraCharge))
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getOneTimePremiumPaymentClientSecretId = async (selectedPlan: OneTimePremiumPlan, couponCode?: string) => {
  try {
    const selectedPlanDto = mapOneTimePremiumPaymentToDto(selectedPlan)
    return await familiadosApiClient.post<OneTimePremiumPaymentClientSecretId>(
      apiRouter.getOneTimePremiumPaymentClientSecretIdPath(),
      { selectedPlan: selectedPlanDto, couponCode },
    )
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getProSubscriptionSignUpPayment = async (selectedPlan: ProSubscriptionPlan, couponCode?: string) => {
  try {
    const selectedPlanDto = mapProSubscriptionPaymentToDto(selectedPlan)
    return await familiadosApiClient.post<ProSubscriptionPaymentClientSecretId>(
      apiRouter.getProSubscriptionSignUpPaymentPath(),
      { selectedPlan: selectedPlanDto, couponCode },
    )
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const getNewPaymentMethodSetup = async () => {
  try {
    return await familiadosApiClient.get<NewPaymentMethodSetup>(apiRouter.getNewPaymentMethodSetupPath())
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const sendCheckoutPaymentData = async (
  cartakerId: string,
  paymentToken: string,
  serviceData: CheckoutPaymentData,
) => {
  try {
    const paymentData = mapCheckoutPaymentDataToDto(serviceData)
    return await familiadosApiClient.post(apiRouter.getCheckoutPaymentDataPath(cartakerId), {
      paymentToken,
      ...paymentData,
    })
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/payment/payment.manager.ts